import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const formatedHour = (hour) => {
  let currentHour = `${hour.slice(0, 2)}:${hour.slice(2, 4)}`;
  const formatedHour = dayjs(currentHour, 'hhmm').format('h:mma');
  const formatedHourNoMinutes = dayjs(currentHour, 'hhmm').format('ha');
  const minutes = formatedHour.split(':')[1] ? formatedHour.split(':')[1].replace('am', '').replace('pm', '') : formatedHour;
  return parseInt(minutes) ? formatedHour : formatedHourNoMinutes;
}

export default formatedHour;
